export default "__VITE_PUBLIC_ASSET__a14d9c88__"